import { useEffect, useState } from "react";

export default function useAuth() {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUser = async () => {
            const token = localStorage.getItem("token");

            if (!token) {
                setLoading(false);
                return;
            }

            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/api/users/me`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!res.ok) {
                    throw new Error("Not authenticated");
                }

                const data = await res.json();
                setUser(data);
            } catch (err) {
                console.error("Auth error:", err);
                setError(err);
                setUser(null);

                // Optional: clear bad token
                localStorage.removeItem("token");
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, []);

    return {
        user,
        loading,
        error,
        isAuthenticated: !!user,
        isAdmin: user?.role === "ADMIN" || user?.role=="LOCALADMIN",
    };
}